import { render, staticRenderFns } from "./purchase-amount-noti.vue?vue&type=template&id=418fec0a&scoped=true&"
import script from "./purchase-amount-noti.vue?vue&type=script&lang=js&"
export * from "./purchase-amount-noti.vue?vue&type=script&lang=js&"
import style0 from "./purchase-amount-noti.vue?vue&type=style&index=0&id=418fec0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418fec0a",
  null
  
)

export default component.exports